import { render, staticRenderFns } from "./AboutOverview.vue?vue&type=template&id=f11d65e2&"
import script from "./AboutOverview.vue?vue&type=script&lang=js&"
export * from "./AboutOverview.vue?vue&type=script&lang=js&"
import style0 from "./AboutOverview.vue?vue&type=style&index=0&id=f11d65e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports